import React from "react";
import { Link } from "react-router-dom";
import { Panel, Button, Table, Loader } from "@culturehq/components";
import * as CHQ from "chq";

import { useGet } from "app/hooks";
import { EventLink } from "app/links";
import { Trans, formatThousand } from "app/utils";

import StarRatingAverage from "components/common/StarRatingAverage";
import { Time } from "components/common/Time";

type EventAnalyticsProps = {
  eventAnalytics: CHQ.EventAnalytics;
};

const EventAnalytics: React.FC<EventAnalyticsProps> = ({ eventAnalytics }) => (
  <tr>
    <td className="max-width-300">
      <EventLink event={eventAnalytics.event} />
    </td>
    <td>
      <Time time={eventAnalytics.startsAt} format="%Y-%m-%d" />
    </td>
    <td>
      {formatThousand(eventAnalytics.attendees.confirmedTwice
        / eventAnalytics.attendees.confirmedOnce)}
    </td>
    <td>
      <StarRatingAverage value={eventAnalytics.rating} />
    </td>
    <td>
      {formatThousand(eventAnalytics.impact.achieved / eventAnalytics.impact.potential)}
    </td>
    <td className="txt-right">
      <Link to={`/events/${eventAnalytics.event.id}/edit`}>
        <Trans>Edit</Trans>
      </Link>
    </td>
  </tr>
);

export type ListEventAnalytics = {
  events: CHQ.EventAnalytics[];
};

const LatestEventsContent: React.FC = () => {
  const get = useGet<ListEventAnalytics>("/analytics/events");

  if (get.getting) {
    return <Loader loading />;
  }

  if (get.error) {
    throw get.error;
  }

  return (
    <Table className="table-responsive">
      <thead>
        <tr>
          <th>
            <Trans>Event</Trans>
          </th>
          <th>
            <Trans>Start Date</Trans>
          </th>
          <th>
            <Trans>Attendees</Trans>
          </th>
          <th>
            <Trans>Rating</Trans>
          </th>
          <th>
            <Trans>Impact</Trans>
          </th>
          <th className="txt-right">
            <Trans>Actions</Trans>
          </th>
        </tr>
      </thead>
      <tbody>
        {get.got.events.map(eventAnalytics => (
          <EventAnalytics
            key={eventAnalytics.event.id}
            eventAnalytics={eventAnalytics}
          />
        ))}
      </tbody>
    </Table>
  );
};

const LatestEvents: React.FC = () => (
  <Panel>
    <Panel.Body className="card_holder">
      <div className="card_title">
        <h3>
          <Trans>Latest Programs</Trans>
        </h3>
        <Button className="view_link">
          <Link to="/admin/events">
            <Trans>View all</Trans>
          </Link>
        </Button>
      </div>
      <div className="card_info">
        <div className="w-100">
          <LatestEventsContent />
        </div>
      </div>
    </Panel.Body>
  </Panel>
);

export default LatestEvents;
